<template>
  <w-column
    v-if="showToggleVisibility"
    cols="auto"
  >
    <w-arrow-down
      :class="contentClass"
      @click="$emit('input', !value)"
    >
      <template #tooltip>
        {{ !value ? $t('Common.unfold') : $t('Common.foldup') }}
      </template>
    </w-arrow-down>
  </w-column>
</template>
<script>

export default {
    name: "WorkUnitPrependHeader",
    props: {
      showToggleVisibility: { type: Boolean, default: true},
      value: { type: Boolean, default: false},
      contentClass: { type: String }
    },
}
</script>
    